import { WIDGET_NAMES } from 'constants/entity-names';


export const ITEM_OPERATION = {
    ADD: 'ADD'
};

export const REQUEST_DATA_FOR_WIDGET_SYNC = {
    [ WIDGET_NAMES.MEMBER_ALERTS_LISTING ]: [ 'itemIds' ]
};
